// Thin fetch wrappers around the admin Cloudflare Pages Functions. All requests send
// the session cookie (credentials: 'include') and throw an Error with the
// server's message on failure so callers can show it directly.

const BASE = '/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}/${path}`, {
    credentials: 'include',
    headers: options.body ? { 'Content-Type': 'application/json' } : undefined,
    ...options,
  });

  let data = null;
  try {
    data = await res.json();
  } catch {
    // no body
  }

  if (!res.ok) {
    throw new Error((data && data.error) || `Request failed (${res.status})`);
  }
  return data;
}

// --- Auth ---
export const login = (username, password) =>
  request('auth-login', { method: 'POST', body: JSON.stringify({ username, password }) });
export const logout = () => request('auth-logout', { method: 'POST' });
export const getMe = () => request('auth-me');

// --- System Access ---
export const listAdminUsers = () => request('admin-users');
export const createAdminUser = (payload) =>
  request('admin-users', { method: 'POST', body: JSON.stringify(payload) });
export const deleteAdminUser = (username) =>
  request(`admin-users?username=${encodeURIComponent(username)}`, { method: 'DELETE' });

// --- Billings and Customers ---
export const listBillings = () => request('billings');
export const getBilling = (id) => request(`billings?id=${encodeURIComponent(id)}`);
export const createBilling = (payload) =>
  request('billings', { method: 'POST', body: JSON.stringify(payload) });
export const updateBilling = (id, payload) =>
  request(`billings?id=${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify(payload) });
export const deleteBilling = (id) =>
  request(`billings?id=${encodeURIComponent(id)}`, { method: 'DELETE' });

// --- Projects ---
export const listProjects = (status) => request(`projects${status ? `?status=${status}` : ''}`);
export const getProject = (id) => request(`projects?id=${encodeURIComponent(id)}`);
export const createProject = (payload) =>
  request('projects', { method: 'POST', body: JSON.stringify(payload) });
export const updateProject = (id, payload) =>
  request(`projects?id=${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify(payload) });

// --- Canvas Despatch ---
export const listCanvasDespatches = () => request('canvas-despatch');

// --- Canvas Library ---
export const listCanvasLibrary = () => request('canvas-library');
export const createCanvasLibrary = (payload) =>
  request('canvas-library', { method: 'POST', body: JSON.stringify(payload) });
export const updateCanvasLibrary = (id, payload) =>
  request(`canvas-library?id=${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify(payload) });
export const deleteCanvasLibrary = (id) =>
  request(`canvas-library?id=${encodeURIComponent(id)}`, { method: 'DELETE' });

export const listServiceRequests = () => request('service-requests');
export const updateServiceRequest = (id, payload) =>
  request(`service-requests?id=${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify(payload) });
export const getSiteSettings = () => request('site-settings');
export const uploadPaymentQr = (qr_image_base64) =>
  request('site-settings', { method: 'POST', body: JSON.stringify({ qr_image_base64 }) });
export const uploadCountryGenericQr = (country, qr_image_base64) =>
  request('site-settings', { method: 'POST', body: JSON.stringify({ country, generic: true, qr_image_base64 }) });
export const uploadCountrySpecifiedQr = (country, days, qr_image_base64) =>
  request('site-settings', { method: 'POST', body: JSON.stringify({ country, days, qr_image_base64 }) });
export const deleteCountryQr = (country, { generic = false, days } = {}) =>
  request('site-settings', {
    method: 'POST',
    body: JSON.stringify({ delete_qr: true, country, generic, days }),
  });
export const saveCountryPaymentModes = (country_modes) =>
  request('site-settings', { method: 'POST', body: JSON.stringify({ country_modes }) });
